import { render, staticRenderFns } from "./CardDefault.vue?vue&type=template&id=60a9afb1&scoped=true&"
import script from "./CardDefault.vue?vue&type=script&lang=js&"
export * from "./CardDefault.vue?vue&type=script&lang=js&"
import style0 from "./CardDefault.vue?vue&type=style&index=0&id=60a9afb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9afb1",
  null
  
)

export default component.exports